import React from 'react';
import { ContentfulGenericPage } from '@jbhi-fi/apis/src/contentful/types';
import { CardGridCardProps } from '../../Card/CardGrid/CardGrid';
import { CardTransformer } from './CardTransformer';
import { CardCoverImage } from '../../Card';
import { format, parseISO } from 'date-fns';
import { MiniCardProps } from '../../MiniCard/MiniCard';
import { ContentfulImage } from '../../ContentfulImage/ContentfulImage';
import { AssetTransformer } from './AssetTransformer';

export abstract class GenericPageTransformer {
  static toCardProps = (entry?: ContentfulGenericPage): CardGridCardProps => {
    const coverImageProps = CardTransformer.toCardCoverImageProps(entry);
    const publishedDate = entry?.fields?.publishedDate || entry?.sys?.createdAt;
    return {
      heading: entry?.fields?.heading,
      cover: coverImageProps ? <CardCoverImage {...coverImageProps} /> : null,
      tagProps: CardTransformer.toTagProps(entry),
      footerProps: {
        leftContent: publishedDate ? format(parseISO(publishedDate), 'd MMM yyyy') : '',
        rightContent: entry?.fields?.parentPage?.fields?.heading,
      },
      showTag: false,
      href: CardTransformer.toHref(entry),
    };
  };

  static toMiniCardProps = (entry?: ContentfulGenericPage): MiniCardProps => {
    const coverImageProps = AssetTransformer.toContentfulImageProps(entry?.fields?.heroLogo);
    return {
      title: entry?.fields?.heading || '',
      image: <ContentfulImage {...coverImageProps} sizes="150px" />,
      destinationUrl: CardTransformer.toHref(entry),
    };
  };
}
